module.exports = __webpack_public_path__ + "static/media/top-bar-collect-regular.43628be8.png";